export function findItemByText(items: any[], text: string) {
  const lowerCaseText = text.toLowerCase();
  // Recursive function to search within an item
  function searchInItem(item: any): boolean {
    // Iterate over the values of the current item
    return Object.values(item).some((value) => {
      // If the value is an object and not null, recursively search within it
      if (typeof value === 'object' && value !== null) {
        return searchInItem(value);
      }
      // If the value is a string, convert it to lowercase and check if it contains the search text
      return String(value).toLowerCase().includes(lowerCaseText);
    });
  }

  // Filter the items array, keeping only those that match the search criteria
  return items.filter((item) => searchInItem(item));
}
